import styled from 'styled-components';


export const FaqContainer = styled.div`
  background-color: #101522;
  padding: 4rem 0 2rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FaqSubscription = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 24px;
  padding: 24px;
  color: #fff;
`;


export const FaqFlex = styled.section`
  display: flex;
  // flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
  color: #fff;
`;

export const FaqSubHeading = styled.p`
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande',
    'Lucida Sans', Arial, sans-serif;
  margin-bottom: 24px;
  font-size: 32px;
  color:#fff;
`;

export const FaqSubText = styled.p`
  margin-bottom: 10px;
  font-size: 20px;
`;

export const FaqSpacing = styled.p`
  margin-bottom: 20px;
  margin-top:20px;
  color: #424240;
`;

